import { render, staticRenderFns } from "./procurement_settle.vue?vue&type=template&id=6eced712&scoped=true"
import script from "./procurement_settle.vue?vue&type=script&lang=js"
export * from "./procurement_settle.vue?vue&type=script&lang=js"
import style0 from "./procurement_settle.vue?vue&type=style&index=0&id=6eced712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eced712",
  null
  
)

export default component.exports